import classNames from 'classnames'
import dayjs from 'lib/dayjs'
import { useTranslation } from 'app/i18n/client'
import { formatToYen } from 'utils'

interface RoomRateDetailProps {
  className?: string
  name: string
  rateDetailList?: {
    totalPrice?: number
    couponDiscountAmount?: number
    rateDetail?: {
      [key: string]: {
        rate: number
      }
    }
    roomRates?: {
      date: string
      tiers: {
        price: number
        name: string
      }[]
      dayTotalRate: number
    }[]
  }[]
}

const RoomRateDetail: React.FC<RoomRateDetailProps> = ({
  name,
  rateDetailList,
  className,
}) => {
  const { t } = useTranslation()
  return (
    <div className={classNames('space-y-2', className)}>
      {rateDetailList?.map((roomDetail, index) => (
        <div
          key={`${name}-room-rate-${index}`}
          className="bg-[#F6FBFD] p-4 space-y-2.5 border border-gray-150"
        >
          {rateDetailList?.length > 1 && (
            <div className="text-secondary text-xs">
              {t('Room Number {{index}}', { index: index + 1 })}
            </div>
          )}
          {roomDetail?.roomRates
            ? roomDetail.roomRates.map((roomRate) => (
                <div
                  key={`${name}-room-rate-${index}-${roomRate.date}`}
                  className="w-full flex justify-between items-center"
                >
                  <div className="text-secondary text-xs">
                    {dayjs(roomRate.date).format('ll')}
                  </div>
                  <div className="text-sm">
                    {formatToYen(roomRate.tiers?.[0]?.price)}
                  </div>
                </div>
              ))
            : roomDetail?.rateDetail &&
              Object.keys(roomDetail?.rateDetail)?.map((date) => (
                <div
                  key={`${name}-room-rate-${index}-${date}`}
                  className="w-full flex justify-between items-center"
                >
                  <div className="text-secondary text-xs">
                    {dayjs(date).format('ll')}
                  </div>
                  <div className="text-sm">
                    {formatToYen(roomDetail?.rateDetail?.[date]?.rate)}
                  </div>
                </div>
              ))}
          <div className="w-full flex justify-between items-center border-t border-gray-150 pt-3">
            <div className="text-secondary text-xs">
              {t('Subtotal of room price')}
            </div>
            <div className="text-sm font-semibold">
              {roomDetail?.roomRates
                ? formatToYen(
                    roomDetail.roomRates.reduce(
                      (sum, rate) => sum + (rate.tiers?.[0]?.price || 0),
                      0,
                    ),
                  )
                : formatToYen(
                    (roomDetail?.totalPrice || 0) +
                      (roomDetail?.couponDiscountAmount || 0),
                  )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default RoomRateDetail
